import { QuestionFlow } from "../components/QuestionFlow";

const QUESTIONS = [
  {
    key: "q1_struggle",
    question: "What feels most true for you right now?",
    micro: "Thank you for sharing that. You're not alone in feeling this way.",
    options: [
      "I feel anxious or on edge most days.",
      "I feel emotionally exhausted or burned out.",
      "I feel disconnected from myself or my purpose.",
      "I'm generally okay, but I want deeper spiritual growth.",
      "Other — I'll share in my own words.",
    ],
  },
  {
    key: "q2_area",
    question: "Which area of your life feels most overwhelming?",
    micro: "It makes sense that you're feeling this — let's keep exploring gently.",
    options: [
      "Work and career.",
      "Relationships.",
      "Inner world — thoughts, emotions, self-talk.",
      "Spiritual connection or meaning.",
      "All of the above.",
    ],
  },
  {
    key: "q3_state",
    question: "How would you describe your current emotional state?",
    micro: "Wherever you are right now is a valid place to begin.",
    options: [
      "I'm barely holding it together.",
      "I'm functioning, but I feel heavy inside.",
      "I'm okay, but something feels off.",
      "I feel open and ready for deeper inner work.",
    ],
  },
];

export default function QualifyingPage() {
  return <QuestionFlow questions={QUESTIONS} stepNumber={2} nextRoute="/explore" pageTestId="qualifying-page" />;
}
